// Parent–child organizations. Contract:
// docs/plans/active/public-api/project-public-api/2026-10-08-parent-child-organizations/design.md

export const CHILD_COMPANY_MANAGE_PERMISSION = 'child_company:manage';
export const CHILD_COMPANY_ACCESS_PERMISSION = 'child_company:access';
export const COMPANY_PARENT_MANAGE_PERMISSION = 'company:parent:manage';

// Held by Owner only. A custom role carrying one of these could let a
// non-Owner place the organization under a parent they control and then
// delegate back in with Owner-equivalent authority.
export const OWNER_ONLY_PERMISSION_KEYS = Object.freeze([COMPANY_PARENT_MANAGE_PERMISSION]);

// Permissions a delegate (a parent organization's key in its child, or a MindCloud
// admin key under X-Company-Id) can never hand out in the organization it acts in:
// it may not create or edit a role carrying one, nor assign or invite into a role
// that carries one. Each would let people the delegate controls keep power after
// the link or the request (API keys), or reach beyond the consent (the organization
// itself, its Owners, members and roles, billing, Embedded setup, the parent link,
// further child organizations). Member create/edit can seat anyone in the child, and
// every member can mint API keys. Seating the first Owner of a child
// the parent created is the one exception, governed by
// resolveParentDelegateMemberRefusal.
export const DELEGATE_RESERVED_PERMISSION_KEYS = Object.freeze(['api_key:manage', CHILD_COMPANY_ACCESS_PERMISSION, CHILD_COMPANY_MANAGE_PERMISSION, 'company:delete', COMPANY_PARENT_MANAGE_PERMISSION, 'embedded:create', 'embedded:delete', 'embedded:edit', 'member:create', 'member:edit', 'member:owner_edit', 'role:manage', 'subscription:manage']);

// Who acts inside a company from outside it, through the public API: a parent
// organization's key (the default; the delegate carries linkId and origin) or
// a MindCloud admin key naming the company in X-Company-Id.
export const DELEGATE_KIND = Object.freeze({
  parent: 'parent',
  mindcloudAdmin: 'mindcloudAdmin'
});

export const COMPANY_PARENT_ORIGIN = Object.freeze({
  CREATED: 'created',
  LINKED: 'linked'
});

export const COMPANY_PARENT_END_REASON = Object.freeze({
  PARENT_RELEASED: 'parent_released',
  CHILD_LEFT: 'child_left',
  COMPANY_DELETED: 'company_deleted'
});

export const COMPANY_LINK_REQUEST_STATUS = Object.freeze({
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  EXPIRED: 'expired'
});

export const COMPANY_LINK_REQUEST_SIDE = Object.freeze({
  PARENT: 'parent',
  CHILD: 'child'
});

export const MAX_CHILDREN_PER_PARENT = 25;
export const MAX_CHILD_CREATIONS_PER_DAY = 10;
export const COMPANY_LINK_REQUEST_TTL_DAYS = 7;
export const MAX_PENDING_OUTGOING_LINK_REQUESTS = 5;
export const MAX_PENDING_INBOUND_LINK_REQUESTS = 5;
